import { useMutation } from "@/compat/reactQuery";
import userAccessPermissionService from "../../services/userAccessPermissionService";

const useAddUserAccessPermission = () =>
  useMutation(userAccessPermissionService.create);

export default useAddUserAccessPermission;
